import { render, staticRenderFns } from "./OrgChart.vue?vue&type=template&id=6854bfbd&scoped=true"
import script from "./OrgChart.vue?vue&type=script&lang=js"
export * from "./OrgChart.vue?vue&type=script&lang=js"
import style0 from "./OrgChart.vue?vue&type=style&index=0&id=6854bfbd&prod&lang=css"
import style1 from "./OrgChart.vue?vue&type=style&index=1&id=6854bfbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6854bfbd",
  null
  
)

export default component.exports